module.exports = "/_next/static/images/5bda5cd4c347147be96a5e62fadb12f0-mail-icon.svg.webp";